
<template>
  <div id="footer" class="container-fluid">
    <div class="first-row">
      <div class="logo">
      <img @click="handleClick" class="logo-pic" src="@/assets/img/logo.png" alt="">
      <div @click="handleClick" class="logo-text">ANT</div>
      </div>
      <div class="product-info">
        <div class="product-text">产品</div>
        <div class="product-item" @click="handleWhatsAppClick()">WhatsApp</div>
        <div class="product-item" @click="handleOTPClick()">一次性验证码</div>
        <div class="product-item" @click="handleMarketingSMSClick()">营销短信</div>
        <div class="product-item" @click="handleNumberFilterClick()">号码筛选</div>
        <div class="product-item" @click="handlePredictiveDialerClick()">预测式外呼</div>
        <div class="product-item" @click="handlePhoneServiceClick()">话机服务</div>
        <div class="product-item" @click="handleOtherServicesClick()">其它服务</div>
      </div>
      <div class="resource-info">
        <div class="resource-text">资源</div>
        <div class="resource-item" @click="handleAPIDocsClick()">API 文档</div>
        <div class="resource-item">帮助中心</div>
        <div class="resource-item">定价</div>
      </div>
      <div class="company-info">
        <div class="company-text">公司</div>
        <div class="company-item" @click="handleAboutUsClick()">关于我们</div>
        <div class="company-item" @click="handleTermsClick()">服务条款</div>
        <div class="company-item" @click="handlePrivacyPolicyClick()">隐私政策</div>
      </div>
    </div>
    <div class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} TITAP LIMITED</div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$router.push("/");
    },
    handleWhatsAppClick() {
      this.$router.push("/product/whatsApp");
    },
    handleOTPClick() {
      this.$router.push("/product/OtpService");
    },
    handleMarketingSMSClick() {
      this.$router.push("/product/marketingSms");
    },
    handleNumberFilterClick() {
      this.$router.push("/product/numberFiltering");
    },
    handlePredictiveDialerClick() {
      this.$router.push("/product/predictiveDiale");
    },
    handlePhoneServiceClick() {
      this.$router.push("/product/phone");
    },
    handleOtherServicesClick() {
      this.$router.push("/product/ivr");
    },
    handleAboutUsClick() {
      this.$router.push("/contactus");
    },
    handleTermsClick() {
      window.location.href = "https://web.antgst.com/privacy-policy";
    },
    handlePrivacyPolicyClick() {
      window.location.href = "https://web.antgst.com/privacy-policy";
    },
    handleAPIDocsClick() {
      window.location.href = "https://doc.antgst.com/";
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  /* background: #474747; */
  background: rgb(107, 107, 107,0.8);
  overflow: hidden;
  padding: 50px 80px 0px 80px;
  .first-row {
    display: flex;
    padding: 0 300px;
    .logo {
      width: 100px;
      height: 70px;
      display: flex;
      flex:1;
      .logo-pic {
        width: 60px;
        height: 60px;
      }
      .logo-text {
        display: flex;
        /* justify-content: center; */
        align-items: center;
        margin-left: 20px;
        font-size: 30px;
        color: rgb(157, 201, 60);
      }
    }
    .product-info {
      flex:1.2;
      display: flex;
      flex-direction: column;
      align-items: center;
      /* border: 1px solid red; */
      .product-text {
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .product-item {
        font-size: 16px;
        margin-bottom: 20px;
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        cursor: pointer;
      }
    }
    .resource-info {
      flex: 1.2;
      display: flex;
      flex-direction: column;
      align-items: center;
      .resource-text {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
      }
      .resource-item {
        font-size: 16px;
        margin-bottom: 20px;
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        cursor: pointer;
      }
    }
    .company-info {
      flex:1.2;
      display: flex;
      flex-direction: column;
      align-items: center;
      .company-text {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .company-item {
        font-size: 16px;
        margin-bottom: 20px;
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        cursor: pointer;
      }
    }
  }
  .copy {
    display: flex;
    border: 1px red soild;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 10px;
  }
}
</style>
<style>  .first-row {
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue